import React from "react";
import { useIntl } from "react-intl";
import { FormGroup } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMicrophone,
  faUpload,
  faMusic,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";

const VOICES = ["Matilda", "Sarah", "James", "Emma"];

interface PromptInputProps {
  prompt: string;
  onPromptChange: (value: string) => void;
  voice: string;
  onVoiceChange: (voice: string) => void;
  languageLabel?: string;
  onToolsClick?: () => void;
  toolsButtonRef?: React.Ref<HTMLButtonElement>;
  onMusicClick?: () => void;
  onSearchClick?: () => void;
}

export function PromptInput({
  prompt,
  onPromptChange,
  voice,
  onVoiceChange,
  languageLabel,
  onToolsClick,
  toolsButtonRef,
  onMusicClick,
  onSearchClick,
}: PromptInputProps) {
  const intl = useIntl();

  return (
    <div className="video-gen-prompt">
      <FormGroup className="mb-0">
        <textarea
          placeholder={intl.formatMessage({ id: "app.videoGen.promptPlaceholder" })}
          value={prompt}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
            onPromptChange(e.target.value);
          }}
          className="form-control video-gen-prompt__textarea"
          rows={4}
        />
      </FormGroup>
      <div className="video-gen-prompt__footer d-flex flex-wrap align-items-center justify-content-between mt-2">
        <div className="d-flex align-items-center gap-2">
          <span className="video-gen-prompt__voice-icon">
            <FontAwesomeIcon icon={faMicrophone} />
          </span>
          <select
            className="form-control form-control-sm video-gen-prompt__voice-select"
            value={voice}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
              onVoiceChange(e.target.value)
            }
          >
            {VOICES.map((v) => (
              <option key={v} value={v}>
                {v}
              </option>
            ))}
          </select>
          <button type="button" className="btn btn-sm btn-outline-secondary" title={intl.formatMessage({ id: "app.videoGen.uploadVoice" })}>
            <FontAwesomeIcon icon={faUpload} />
          </button>
        </div>
        <div className="d-flex align-items-center gap-2">
          {onMusicClick && (
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={onMusicClick}
              title={intl.formatMessage({ id: "app.videoGen.music" })}
            >
              <FontAwesomeIcon icon={faMusic} />
            </button>
          )}
          {onSearchClick && (
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={onSearchClick}
              title={intl.formatMessage({ id: "app.videoGen.search" })}
            >
              <FontAwesomeIcon icon={faMagnifyingGlass} />
            </button>
          )}
          {onToolsClick && (
            <button
              ref={toolsButtonRef}
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={onToolsClick}
            >
              {intl.formatMessage({ id: "app.videoGen.tools" })}
            </button>
          )}
          {languageLabel && (
            <button type="button" className="btn btn-sm btn-outline-secondary dropdown-toggle">
              {languageLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
